/**
 * Sidebar Interactions (ES6 version, no jQuery)
 * - Sticky sidebar behavior on scroll (desktop)
 * - Horizontal drag/scroll on mobile
 * - Active section highlighting while scrolling
 */

export function initSidebarInteractions() {
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;

    const sidebarContainer = sidebar.querySelector('.container');
    const windowHeight = () => window.innerHeight;
    let lastScrollTop = 0;
    let winWidth = window.innerWidth;

    /* --------------------------------------------
     *  Initialization
     * -------------------------------------------- */
    setupMobileScroll();
    handleScroll(); // initial call

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => {
        winWidth = window.innerWidth;
        setupMobileScroll();
    });

    /* --------------------------------------------
     *  Functions
     * -------------------------------------------- */

    function handleScroll() {
        const scrollTop = window.scrollY;
        stickSidebar(scrollTop);
        setSidebarActive(scrollTop);
        lastScrollTop = scrollTop;
    }

    function stickSidebar(scrollTop) {
        const isHome = document.querySelector('main')?.classList.contains('home') ||
            sidebar.classList.contains('sidebar_ad');

        const limit = document.querySelector('.sidebar_limit');
        if (!limit) return;

        const headimg = document.querySelector('.headimg');
        const featured = document.querySelector('section.featured');
        const pageTitle = document.querySelector('.page-title');
        const autozoeker = document.querySelector('#autozoeker');
        const article = document.querySelector('article.single');

        const headerHeight = headimg?.offsetHeight || featured?.offsetHeight || 0;
        const pageTitleH = pageTitle?.offsetHeight || autozoeker?.offsetHeight || 0;

        const plusY = winWidth > 992 ? (isHome ? headerHeight + 20 : pageTitleH + 20) : 0;
        const plusX = winWidth > 992 ? 129 : -20;

        const bottomY = isHome
            ? limit.offsetTop + limit.offsetHeight - 700
            : pageTitleH + (article?.offsetHeight || 0) - 100;

        // Apply sticky / top / bottom states
        if (!sidebar.classList.contains('sticky')) {
            if ((scrollTop + plusX) >= sidebar.offsetTop && !sidebar.classList.contains('bottom')) {
                sidebar.classList.add('sticky');
                sidebar.classList.remove('top');
            } else if (scrollTop < bottomY && !sidebar.classList.contains('top')) {
                sidebar.classList.remove('bottom');
                sidebar.classList.add('sticky');
            }
        } else {
            if (scrollTop <= plusY) {
                sidebar.classList.remove('sticky');
                sidebar.classList.add('top');
            } else if (scrollTop > bottomY) {
                sidebar.classList.remove('sticky');
                sidebar.classList.add('bottom');
            }
        }
    }

    function setSidebarActive(scrollTop) {
        const anchors = document.querySelectorAll('a[name]');
        if (!anchors.length) return;

        let currentId = '';
        anchors.forEach(anchor => {
            if ((anchor.offsetTop - scrollTop) <= windowHeight() * 0.5) {
                currentId = anchor.getAttribute('name');
            }
        });

        const activeLink = sidebar.querySelector(`a[href="#${currentId}"]`);
        const prevActive = sidebar.querySelector('.active');
        if (activeLink && activeLink !== prevActive) {
            prevActive?.classList.remove('active');
            activeLink.classList.add('active');
        }
    }

    function setupMobileScroll() {
        if (!sidebarContainer || winWidth > 992) return;

        // Calculate total width of all links
        const links = Array.from(sidebar.querySelectorAll('a'));
        const totalWidth = links.reduce((sum, link) => sum + link.offsetWidth, 0);
        sidebarContainer.style.width = `${totalWidth}px`;

        // Only enable horizontal scroll if content overflows
        if (sidebarContainer.scrollWidth <= sidebar.offsetWidth) return;

        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        // Remove previous listeners (if any)
        sidebarContainer.onmousedown = null;
        sidebarContainer.onmousemove = null;
        sidebarContainer.onmouseup = null;
        sidebarContainer.onmouseleave = null;

        sidebarContainer.addEventListener('mousedown', e => {
            isDragging = true;
            sidebarContainer.classList.add('dragging');
            startX = e.pageX - sidebarContainer.offsetLeft;
            scrollLeft = sidebarContainer.scrollLeft;
        });

        sidebarContainer.addEventListener('mouseleave', () => {
            isDragging = false;
            sidebarContainer.classList.remove('dragging');
        });

        sidebarContainer.addEventListener('mouseup', () => {
            isDragging = false;
            sidebarContainer.classList.remove('dragging');
        });

        sidebarContainer.addEventListener('mousemove', e => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - sidebarContainer.offsetLeft;
            const walk = (x - startX) * 1.2; // scroll speed factor
            sidebarContainer.scrollLeft = scrollLeft - walk;
        });
    }
}
